import { GAME_RULES } from "./util";

var isDev = /localhost:56\d{2}/.test(location.href);

const initNoviceHelpList = () => {
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}/web/rest/configs2`,
    error: function () {},
  })
    .done(({ result }) => {
      if (result?.["user.lotterys"]?.length) {
        const availableLotteries = result?.["user.lotterys"]?.map(({ id }) => id);
        $(`.help-more-container .help-more-container__tab`).append("<p class='tab-title'>游戏规则</p>");

        GAME_RULES.forEach(({ subtitle, topics }) => {
          if (topics.some(({ hash }) => availableLotteries.includes(hash))) {
            const topicList = $("<ul></ul>");
            $(`.help-more-container .help-more-container__tab`).append(`<p class='tab-subtitle'>${subtitle}</p>`);

            topics.forEach(({ description, hash, url }) => {
              if (availableLotteries.includes(hash)) {
                topicList.append(`<li data-hash="${hash}" data-url="${url}">${description}</li>`);
              }
            });

            $(`.help-more-container .help-more-container__tab`).append(topicList);
          }
        });
      }
    })
    .always(() => {
      const origin = location.origin;
      const currentHash = location.hash.slice(1);

      const iframe = $(".help-more-container__content iframe");
      iframe[0].setAttribute("src", `${origin}/util/faq/dsn/faq-recharge.html`);

      if (currentHash) {
        const path = $(`.help-more-container .help-more-container__tab ul li[data-hash="${currentHash}"]`).attr(
          "data-url"
        );

        const iframe = $(`.help-more-container__content iframe`);
        iframe[0].setAttribute("src", `${origin}${path}${currentHash}.html`);
      }

      $(".help-more-container .help-more-container__tab ul li").on("click", function () {
        location.hash = $(this).attr("data-hash");
        const path = $(this).attr("data-url");
        const currrentTab = location.hash.slice(1);

        $(".help-more-container .help-more-container__tab ul li").removeClass("active");
        $(this).addClass("active");

        const origin = location.origin;
        const currentIframe = $(`.help-more-container__content iframe`);

        currentIframe[0].setAttribute("src", `${origin}${path}${currrentTab}.html`);
        $("html").scrollTop(0);
      });
    });
};

$(function () {
  const path = location.pathname.split("/").pop();

  if (path === "help-more-novice.html") {
    initNoviceHelpList();
  }
});

$(".help-more-container .help-more-container__tab .tab-header").on("click", function () {
  location.href = "./help.html";
});
